import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './KioskProductListLayout.styles';
import {
  KioskWelcomeFooter,
  KioskWelcomeHeader,
  KioskProductListMain
} from '..';

export class KioskProductListLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };
  state = {
    stepTitle: '',
    pageTitle: 'ShopNow'
  };

  render() {
    const { classes } = this.props;
    var customFooterBottom;
    if (window.screen.width >= 1440) {
      customFooterBottom = '-25%';
    } else {
      customFooterBottom = '0%';
    }

    return (
      <div className={classNames(classes.container)}>
        <KioskWelcomeHeader />
        <KioskProductListMain />
        <KioskWelcomeFooter customFooterBottom={customFooterBottom} />
        {/* <KioskIdelScreen /> */}
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(KioskProductListLayout);
